import { render, staticRenderFns } from "./TypesFormTemplate.vue?vue&type=template&id=04f1bc6d&scoped=true&lang=html"
import script from "./TypesFormTemplate.vue?vue&type=script&lang=js"
export * from "./TypesFormTemplate.vue?vue&type=script&lang=js"
import style0 from "./TypesFormTemplate.vue?vue&type=style&index=0&id=04f1bc6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1bc6d",
  null
  
)

export default component.exports